// 三国志 — character data (server-safe, NO portrait imports). Generated by create-mod.
import { RULES } from '../dominion/rules';
import data from './sanguo-excerpt.data.json';

export const CHARACTERS_DATA = data.roster;

export function getCharacterById(id) {
  return CHARACTERS_DATA.find(c => c.id === id);
}

export function getStartingMoney(character) {
  return RULES.core.baseStartingMoney + character.stats.capital * RULES.stats.capital.startingMoneyBonus;
}
